import useMobileDetect from "@carotek/hooks/UsMobileDetect";
import CarotekColors from "@carotek/utils/Colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface RequestForQuoteBadgeStyles {
    requestForQuoteBadgeWrapper?: InjectableCss;
    mobileWrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const RequestForQuoteBadgeStyles: RequestForQuoteBadgeStyles = {
    requestForQuoteBadgeWrapper: {
        css: css`
            padding: 0 10px;
            background-color: ${getColor("danger")};
            color: ${CarotekColors.white};
            position: fixed;
            top: 0;
            right: 0;
            bottom: 90px;
            transform: rotate(90deg) translate(50%, 50%);
            transform-origin: 100% 50%;
            z-index: 9999;
            cursor: pointer;
            text-transform: uppercase;
            height: 25px;
            margin: auto;
            font-size: 14px;
            :hover {
                text-decoration: underline;
            }
        `,
    },
    mobileWrapper: {
        css: css`
            background-color: ${getColor("danger")};
            background-image: url(https://d17h1m9h5c5gcj.cloudfront.net/userfiles/_images-pdfs-general/email_support.svg);
            border-radius: 50%;
            display: block;
            height: 40px;
            width: 40px;
            background-position: 7px 10px;
            background-repeat: no-repeat;
            background-size: 24px;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
            position: fixed;
            z-index: 99;
            left: 20px;
            bottom: 50px;
        `,
    },
};

const styles = RequestForQuoteBadgeStyles;

export const RequestForQuoteBadge = () => {
    const { isMobile } = useMobileDetect();

    const openContactUsPage = () => {
        if (typeof window !== undefined) {
            const url = "/contact-us";
            const windowName = "_blank";
            const features = "width=800,height=600,top=100,left=100,resizable=yes,scrollbars=yes";

            window.open(url, windowName, features);
        }
    };

    if (isMobile) {
        return <StyledWrapper onClick={openContactUsPage} {...styles.mobileWrapper}></StyledWrapper>;
    }

    return (
        <StyledWrapper {...styles.requestForQuoteBadgeWrapper} onClick={openContactUsPage}>
            {translate("Request Info or Quote")}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: RequestForQuoteBadge,
    definition: {
        group: "Header",
        icon: "list-ul",
        displayName: "Request for Quote Badge",
    },
};

export default widgetModule;
